import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_DOC_BOX_MGMT_INFO,
    SG_DOC_TRGT_INFO_LIST,
} from "@/tra/tancis/ptli/elctdoc/box/services/PtliDocBoxMgmtService";

/*
 * Update Document Box
 * !== 문서함 수정 ==!
 */
export const PTLI0703002S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0047", "auth_ptli0004", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { intfId } = useParams();

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "CGM0176" }, // 내외부 유형 코드
            { area: "comnCd", comnCd: "COM0024" }, // 업무 분류 코드
            { area: "comnCd", comnCd: "COM0064" }, // 사용 여부 코드
            { area: "comnCd", comnCd: "COM0069" }, // 대상 유형 코드
            { area: "comnCd", comnCd: "COM0070" }, // 송수신 유형 코드
            { area: "comnCd", comnCd: "COM0071" }, // 연계 프로토콜 코드
            { area: "comnCd", comnCd: "COM0072" }, // 연계 데이터 유형 코드
            { area: "comnCd", comnCd: "COM0073" }, // 연계 처리 방법 코드
            { area: "comnCd", comnCd: "COM0074" }, // 연계 주기 코드
            { area: "comnCd", comnCd: "COM0077" }, // 송수신 구분 코드
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        docBoxForm: useForm({
            defaultSchema: SF_DOC_BOX_MGMT_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        docBoxTrgtList: useGrid({
            defaultSchema: SG_DOC_TRGT_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get document box !== 문서함 정보 조회 ==!
        getElctDocBox: useFetch({
            api: () => APIS.getElctDocBox(intfId),
            enabled: !!intfId,
            onSuccess: (data) => {
                const elctDocBox = data.elctDocBox.content;
                const elctDocTrgtList = elctDocBox.elctDocTrgtList;

                form.docBoxForm.setValues(elctDocBox);

                grid.docBoxTrgtList.setData(comnUtils.getGridData(elctDocTrgtList));
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {},
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00018" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
        // Update Document Box !== 문서함 수정 ==!
        updateElctDocBox: useFetch({
            api: (data) => APIS.updateElctDocBox({ ...data }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {},
                    close: false,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.docBoxForm.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.00006", // An error occurred during processing.
                });
            },
        }),
        // delete document !== 문서함 삭제 ==!
        deleteElctDocBox: useFetch({
            api: () => APIS.deleteElctDocBox(intfId),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00060", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        navigate(URLS.ptli0703001q);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Save Button Click Event Handler  !== 문서함 수정 ==!
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.docBoxForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.docBoxForm.handleSubmit(
                () => {
                    const data = form.docBoxForm.getValues();
                    const elctDocTrgtList = grid.docBoxTrgtList.getData();

                    // Setting Document Target List !== 문서 대상 목록 세팅 ==!
                    data.elctDocTrgtList = elctDocTrgtList;

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.updateElctDocBox.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // Delete document target list deletion event !== 문서 대상 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridDocTrgtList: () => {
            const seltList: any[] = grid.docBoxTrgtList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }

            modal.openModal({
                content: "msg.00103",
                onConfirm: () => {
                    grid.docBoxTrgtList.deleteRow("checkbox");
                },
            });
        },
        // Delete Document box !== 문서함 삭제 ==!
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteElctDocBox.fetch();
                },
            });
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_DOC_BOX_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.intfId} readOnly={true} />
                            <Group.Control {...form.docBoxForm.schema.intfNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.sndrNm} />
                            <Group.Control {...form.docBoxForm.schema.rcvrNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.sendSysmNm} />
                            <Group.Control {...form.docBoxForm.schema.rcpnSysmNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.inexTpCd} />
                            <Group.Control {...form.docBoxForm.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.sndrcvDvnCd} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_API_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            {/* <Group.Control {...form.docBoxForm.schema.rspnTmout} /> */}
                            <Group.Control {...form.docBoxForm.schema.sndrcvTpCd} />
                            <Group.Control {...form.docBoxForm.schema.lnkgPrtclCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.lnkgDtaTpCd} />
                            <Group.Control {...form.docBoxForm.schema.prcssMetdCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.lnkgCycleCd} />
                            <Group.Control {...form.docBoxForm.schema.apiUrlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.msgBodyLogYn} />
                            <Group.Control {...form.docBoxForm.schema.trscLogYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.actvtYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.inpInfoCn} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxForm.schema.otptInfoCn} controlSize={10} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_DOC_TRGT_LIST"} titleSize={2}></Group.Title>
                        </Layout.Left>
                        {/* <Layout.Right>
                            <Button
                                role="gridAdd"
                                onClick={() => {
                                    grid.docBoxTrgtList.addRow();
                                }}
                            ></Button>
                            <Button
                                role="gridDelete"
                                onClick={() => {
                                    handler.click_Btn_DeleteGridDocTrgtList();
                                }}
                            ></Button>
                        </Layout.Right> */}
                    </Layout>
                    <Group.Section>
                        <Grid {...grid.docBoxTrgtList.grid} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0703001q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                    <Layout.Button
                        role={"delete"}
                        onClick={() => {
                            handler.onDeleteBtnClick();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
